import { render, staticRenderFns } from "./EditOption.vue?vue&type=template&id=6a04c822"
import script from "./EditOption.vue?vue&type=script&lang=js"
export * from "./EditOption.vue?vue&type=script&lang=js"
import style0 from "./EditOption.vue?vue&type=style&index=0&id=6a04c822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports